import bankaccService from '../../services/bankaccs'

const state = {
    loading: false,
    errors: null,
    bankaccs:[] ,
}

const actions = {
    getAll({ commit }) {
        commit('BANKACC_LOADING', true)
        bankaccService.getAll().then(
            response => {

                commit('LOAD_BANKACCS', response.data)
                commit('BANKACC_LOADING', false)
                commit('BANKACC_FAILURE', null)
            },
            error => {
                commit('BANKACC_FAILURE', error)
                commit('BANKACC_LOADING', false)
            }
        )
    },
    add({ commit }, data) {
        commit('BANKACC_LOADING', true)
        commit('BANKACC_FAILURE', null)

        bankaccService.add(data).then(
            response => {
                data.id = response.data.id
                commit('ADD_BANKACC', data)
                commit('BANKACC_LOADING', false)

            },
            error => {
                commit('BANKACC_FAILURE', error)
                commit('BANKACC_LOADING', false)
            }
        )
    },
    update({ commit }, data) {
        commit('BANKACC_LOADING', true)
        commit('BANKACC_FAILURE', null)
        data.bankacc.roles = "bankacc"
        bankaccService.update(data.bankacc)
            .then(
                response => {
                    commit('UPDATE_BANKACC', data)
                    commit('BANKACC_LOADING', false)

                },
                error => {
                    commit('BANKACC_FAILURE', error)
                    commit('BANKACC_LOADING', false)
                }
            )


    },
    delete({ commit }, data) {
        commit('BANKACC_LOADING', true)
        commit('BANKACC_FAILURE', null)
        bankaccService.delete(data.bankacc.id)
            .then(
                response => {

                    commit('DELETE_BANKACC', data)
                    commit('BANKACC_LOADING', false)

                },
                error => {
                    commit('BANKACC_FAILURE', error)
                    commit('BANKACC_LOADING', false)
                }
            )
    }
}

const mutations = {
    ADD_BANKACC(state, payload) {
        state.bankaccs.unshift(payload);
    },
    LOAD_BANKACCS(state, payload) {
        state.bankaccs = payload
    },
    UPDATE_BANKACC(state, payload) {
        Object.assign(state.bankaccs[payload.index], payload.bankacc);
    },
    DELETE_BANKACC(state, payload) {
        state.bankaccs.splice(payload.index, 1)
    },
    BANKACC_FAILURE(state, payload) {
        state.errors = payload
    },

    BANKACC_LOADING(state, payload) {
        state.loading = payload
    },
}


const getters = {
    BANKACCS: state => {
        return state.bankaccs
    },

    BANKACC_ERROR: state => {
        return state.errors
    },

    BANKACC_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/bankaccs.js